import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../features/common/headerSlice';
import PropTypes from 'prop-types';

function ErrorPage(props) {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setPageTitle({ title: 'Error' }));
	}, []);

	return (
		<div className={'error-page flex flex-col justify-center text-center'}>
			<div className={'max-w-[50%] m-auto font-bold tracking-wide'}>
				<p className={'text-2xl font-bold tracking-wide mb-10'}>
					⚠️ There was an error loading this page ⚠️
				</p>
				<p className={'text-lg mb-10'}>
					Please click the button below to reload the page, or refresh the page
					and log in again. If the problem persists, please contact{' '}
					<a
						className={'hover:underline'}
						href="mailto:support@connected-performance.com"
					>
						support@connected-performance.com
					</a>
					.
				</p>
			</div>
			{props.resetErrorBoundary && (
				<div>
					<button
						className={'btn btn-accent'}
						onClick={props.resetErrorBoundary}
					>
						🔄 Try Again
					</button>
				</div>
			)}
		</div>
	);
}

ErrorPage.propTypes = {
	resetErrorBoundary: PropTypes.func.isRequired,
};

export default ErrorPage;
